import React, {useMemo} from 'react'

interface TocEntry {
  id: string
  text: string
  level: number
}

interface Props {
  markdownBody: string
  hasFaqs?: boolean
}

const HelpTableOfContents: React.FC<Props> = ({markdownBody, hasFaqs}) => {
  const headings = useMemo(() => {
    const entries: TocEntry[] = []
    const lines = markdownBody.split('\n')
    for (const line of lines) {
      const match = line.match(/^(#{2,3})\s+(.+)$/)
      if (match) {
        const level = match[1].length
        const text = match[2].trim()
        const id = text
          .toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-')
        entries.push({id, text, level})
      }
    }
    if (hasFaqs) {
      entries.push({id: 'faqs', text: 'Frequently Asked Questions', level: 2})
    }
    return entries
  }, [markdownBody, hasFaqs])

  if (headings.length === 0) return null

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault()
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({behavior: 'smooth'})
    }
  }

  return (
    <div className='card shadow-sm help-toc mb-5'>
      <div className='card-body py-4 px-5'>
        <h6 className='fw-bold text-gray-800 mb-3'>Table of Contents</h6>
        <ul className='toc-list'>
          {headings.map((heading, idx) => (
            <li
              key={`${heading.id}-${idx}`}
              className={`toc-item ${heading.level === 3 ? 'toc-h3' : ''}`}
            >
              <a href={`#${heading.id}`} onClick={(e) => handleClick(e, heading.id)}>
                {heading.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export {HelpTableOfContents}
